<div *ngIf="creditSummary">
    {{creditSummary.totalCosts}}
    <i *ngIf="displayModalIcon" class="bi bi-question-circle ms-1"
        (click)="openSummaryExplanationModal()"></i>
</div>